function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1315_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1295_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1296_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1297_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1314_",
  d: "M17.3,22.6h-1.8v-6.8c0-0.3-0.2-0.6-0.5-0.7c-0.3-0.1-0.6-0.1-0.8,0.2l-1.9,1.9c-0.3,0.3-0.3,0.8,0,1 c0.3,0.3,0.8,0.3,1,0l0.7-0.7v5h-1.8c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h5.1c0.4,0,0.7-0.3,0.7-0.7S17.7,22.6,17.3,22.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1313_",
  d: "M16.8,28.9c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5C17.2,29,17,28.9,16.8,28.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1311_",
  d: "M26.1,11.4c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2 C25.7,11.7,25.9,11.6,26.1,11.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1303_",
  d: "M35.2,21.8c-1.7-1.7-3.8-2.6-6-2.7V5.2C29.2,4,28.2,3,27,3h-4V2.5C23,1.1,21.9,0,20.5,0 C19.1,0,18,1.1,18,2.5V3h-6.7V2.5c0-1.4-1.1-2.5-2.5-2.5S6.2,1.1,6.2,2.5V3h-4C1,3,0,4,0,5.2v23c0,1.2,1,2.2,2.2,2.2h11.6 c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H2.2c-0.4,0-0.7-0.3-0.7-0.7V11.7h21.1c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H1.5v-5 c0-0.4,0.3-0.7,0.7-0.7h4v1.2c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V4.5H18v1.2c0,1.4,1.1,2.5,2.5,2.5S23,7.1,23,5.7V4.5h4 c0.4,0,0.7,0.3,0.7,0.7V19c-2.2,0.2-4.3,1.1-6,2.7C20,23.6,19,26,19,28.5s1,4.9,2.8,6.7c1.9,1.9,4.3,2.8,6.7,2.8 s4.9-0.9,6.7-2.8C38.9,31.5,38.9,25.5,35.2,21.8z M9.8,5.7c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1V2.5c0-0.6,0.5-1,1-1 c0.6,0,1,0.5,1,1V5.7z M21.5,5.7c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1V2.5c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1V5.7z M34.2,34.2 c-3.1,3.1-8.2,3.1-11.3,0c-3.1-3.1-3.1-8.2,0-11.3c1.6-1.6,3.6-2.3,5.7-2.3c2.1,0,4.1,0.8,5.7,2.3C37.3,26,37.3,31,34.2,34.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1302_",
  d: "M28.5,33.4c-0.4,0-0.7,0.3-0.7,0.7v0.5c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-0.5 C29.2,33.7,28.9,33.4,28.5,33.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1301_",
  d: "M28.5,23.6c0.4,0,0.7-0.3,0.7-0.7v-0.5c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7v0.5 C27.8,23.3,28.1,23.6,28.5,23.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1300_",
  d: "M22.9,27.8h-0.5c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h0.5c0.4,0,0.7-0.3,0.7-0.7 S23.3,27.8,22.9,27.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1299_",
  d: "M34.7,27.8h-0.5c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h0.5c0.4,0,0.7-0.3,0.7-0.7 S35.1,27.8,34.7,27.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1298_",
  d: "M31.9,24l-3.4,3.4L27.1,26c-0.3-0.3-0.8-0.3-1,0c-0.3,0.3-0.3,0.8,0,1l1.9,2c0.1,0.1,0.3,0.2,0.5,0.2 h0c0.2,0,0.4-0.1,0.5-0.2l3.9-3.9c0.3-0.3,0.3-0.8,0-1C32.7,23.7,32.2,23.7,31.9,24z"
})))));

function SvgHarmonogram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 38",
    style: {
      enableBackground: "new 0 0 38 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmonogram);
export default __webpack_public_path__ + "static/media/harmonogram.c97631ad.svg";
export { ForwardRef as ReactComponent };